var quiz = {
    questions: [{
        text: "You are an options trader and a client approaches you to buy a call option on this building (where we are now sitting).  You’d be very reluctant to sell a call on this building primarily because:",
        responses: [{
            text: "it’s not possible to estimate the volatility of this asset;",
            index: 'A'
          },
          {
            text: "the property market (of which this asset is a part) is not complete; ",
            index: 'B',
            correct: true
          },
          {
            text: "Transaction costs for this trade would be too high;",
            index: 'C'
          },
          {
            text: "No closed form solution / model (Black-Scholes type) exists for such an option;",
            index: 'D'
          }
        ]
      },
      {
        text: "You are trading an asset that is capped at 100 (like the Eurodollar futures Contract which is capped at 100 and cannot go above this value (implying an interest rate of zero). The asset is currently trading at 100. What is the value of a 100-strike call and a 100-strike put?",
        responses: [{
            text: "The call will be valued at zero and the put value will be infinite (very large);",
            index: 'A'
          },
          {
            text: "Both the call and the put will be valued at zero",
            index: 'B'
          },
          {
            text: "The call will be valued slightly more than zero and the put value will be extremely\r\ndifficult to determine (as the put-call parity will break down at 100);\r\n",
            index: 'C',
            correct: true
          },
          {
            text: "The call and put will both be valued at infinity (very large)",
            index: 'D',
          }
        ]
      },
      {
        text: "EUR/USD volatility is 10% and is represented by a vector of length 10 from the origin (USD). GBP/USD volatility is 8% and is represented by a vector of length 8 from the origin (USD). If the correlation between EUR/USD and GBP/USD is zero then the angle between the two vectors will be: ",
        responses: [{
            text: "90 degrees",
            index: 'A',
          },
          {
            text: "45 degrees",
            index: 'B'
          },
          {
            text: "25 degrees",
            index: 'C'
          },
          {
            text: "Zero degree",
            index: 'D',
            correct: true
          }
        ]
      },
      {
        text: "A one year at the money (ATM) call option on a stock costs $1. Assuming low interest rates and no transaction costs and volatility skew, a two-year ATM option\r\non the same stock will cost:\r\n",
        responses: [{
            text: "$1.15;",
            index: 'A'
          },
          {
            text: "$1.41",
            index: 'B',
            correct: true
          },
          {
            text: "$2.00",
            index: 'C',
          },
          {
            text: "$2.15",
            index: 'D'
          }
        ]
      },
      {
        text: "Bank A with a capital of $1 million enters into a game of coin tossing with Bank B with a capital of $10,000. Bank A wins $1 every time a “head” shows up and loses $1 every time a “tail” shows up. It’s a very cruel world and the game (the show) must go on until one of them goes bankrupt. The probability of Bank B going bankrupt is:",
        responses: [{
            text: "0.99%",
            index: 'A'
          },
          {
            text: "10%",
            index: 'B'
          },
          {
            text: "50%",
            index: 'C'
          },
          {
            text: "99.01% ",
            index: 'D',
            correct: true
          }
        ]
      }
    ]
  },
  userResponseSkelaton = Array(quiz.questions.length).fill(null);
import {
  bus
} from '../../main';
var $ = window.jQuery = require('jquery');
import VueCircle from 'vue2-circle-progress/src/index.vue'
import Vue from 'vue'
export default {
  name: 'quiz-format',
  components: {
    VueCircle
  },
  props: [],
  data() {
    return {
      fill: {
        color: "#0cbfe9"
      },
      quiz: quiz,
      questionIndex: 0,
      userResponses: [],
      quizStarted: true,
      isActive: false,
      totalTime: 90,
      totalScore: 0,
      countDown: {
        minutes: "00",
        seconds: "00"
      }
    }
  },
  computed: {

  },
  mounted() {
    console.log("Quiz Finance");
    var totalTime = new Date();
    totalTime.setSeconds(totalTime.getSeconds() + this.totalTime);
    this.initializeTimer(totalTime)
  },
  methods: {
    selectOption: function(index) {
      Vue.set(this.userResponses, this.questionIndex, index);
    },
    next: function() {
      if (this.questionIndex < this.quiz.questions.length) {
        this.questionIndex++;
        this.score()
      }
    },
    prev: function() {
      if (this.quiz.questions.length > 0) this.questionIndex--;
    },
    // Return "true" count in userResponses
    score: function() {
      var score = 0;
      for (let i = 0; i < this.userResponses.length; i++) {
        if (
          typeof this.quiz.questions[i].responses[
            this.userResponses[i]
          ] !== "undefined" &&
          this.quiz.questions[i].responses[this.userResponses[i]].correct
        ) {
          score = score + 1;
        }
      }
      this.totalScore = score;
      return score;
    },

    //   CountDown
    initializeTimer: function(endTime) {
      var _self = this;

      function updateClock() {
        let remainTime = _self.getTimeRemaining(endTime)
        _self.countDown = remainTime;
        _self.UpdatePercentage(remainTime.total);
        if (remainTime.total <= 0) {
          clearInterval(timeinterval);
        }
      }
      updateClock();
      var timeinterval = setInterval(updateClock, 1000);
    },
    getTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    UpdatePercentage(remainTime) {
      let totalTime = (this.totalTime) * 1000;
      let percentage = 100 - ((remainTime * 100) / totalTime)
      if (this.$refs.timerRef)
        this.$refs.timerRef.updateProgress(percentage);
    },
    showCategory() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('showQuizGameFinance', false);
      }, 500);
      setTimeout(() => {
        bus.$emit('hideQuizCategory', true);
      }, 500);
      setTimeout(() => {
      $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 600);
    },
    QuizGamePopupClose() {
      $(".quizzort_main_wrp").removeClass("popup_active");
      setTimeout(() => {
        bus.$emit('showQuizGameFinance', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
    }
  },
}